import { FC, useRef, useState } from 'react'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import { FormatColorFill } from '@mui/icons-material'

import { ColorPicker } from './ColorPicker'

export interface ColorPickerFieldProps {
  label: string
  value?: string
  helperText?: string
  onChange: (value: string | undefined) => void
}

export const ColorPickerField: FC<ColorPickerFieldProps> = ({ label, value, helperText, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleChange = (newColor: string) => {
    onChange(newColor || undefined)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Box ref={containerRef} sx={{ position: 'relative' }}>
      <TextField
        fullWidth
        label={label}
        value={value || ''}
        onChange={e => {
          const val = e.target.value
          if (val === '' || (val.startsWith('#') && val.length <= 7)) {
            onChange(val || undefined)
          }
        }}
        helperText={helperText}
        InputProps={{
          startAdornment: value ? (
            <InputAdornment position='start'>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  backgroundColor: value,
                  border: '1px solid #ccc',
                  borderRadius: 1,
                }}
              />
            </InputAdornment>
          ) : null,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton size='small' onClick={() => setIsOpen(true)}>
                <FormatColorFill fontSize='small' />
              </IconButton>
            </InputAdornment>
          ),
        }}
        placeholder='#000000'
      />
      {isOpen && (
        <ColorPicker
          open={isOpen}
          color={value}
          onChange={handleChange}
          onClickOutside={handleClose}
          sx={{ position: 'absolute', zIndex: 1300, right: 0, top: '100%', mt: 1 }}
        />
      )}
    </Box>
  )
}
